import { render } from "./DistributorShop.vue?vue&type=template&id=68ecdfda&scoped=true&ts=true"
import script from "./DistributorShop.vue?vue&type=script&lang=ts"
export * from "./DistributorShop.vue?vue&type=script&lang=ts"

import "./DistributorShop.vue?vue&type=style&index=0&id=68ecdfda&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ecdfda"]])

export default __exports__